/* ============
 * Site Languages Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/siteLanguages/state.js